import { scrollToAndLock } from '../ui/util';
import { NAV_SECTIONS } from './components-v2/constants';
const { techSpecs: specsNAV } = NAV_SECTIONS;

export const scrollToSpecsAndConditionallyLockView = (shouldNotLockView, options = {}) => {
    try {
        const accordionTarget = document.getElementById(specsNAV.mobileHash);
        const sectionTarget = document.getElementById(specsNAV.hash);
        const isExpanded = accordionTarget && accordionTarget.getAttribute('aria-expanded') === 'true';
        if (accordionTarget && !isExpanded) {
            accordionTarget.click();
        } else if (!sectionTarget) {
            return;
        } else if (shouldNotLockView) {
            sectionTarget.scrollIntoView();
        } else {
            try {
                return scrollToAndLock(sectionTarget, options);
            } catch (e) {}

            sectionTarget.scrollIntoView();
        }
    } catch (e) {}
};
